import { render, staticRenderFns } from "./VStatsCard.vue?vue&type=template&id=7aa82a79&"
import script from "./VStatsCard.vue?vue&type=script&lang=js&"
export * from "./VStatsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports